import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { LOCAL_URL, API_REQUESTS } from '../../helper/constant'



export const GET_LIST_USER_NOTIFICATION = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.NOTIFICATION_USER}/getlist`, { params: payload });
    dispatch({
      type: Types.GET_LIST_USER_NOTIFICATION,
      newNotification: response.data.data.newNotification,
      oldNotification: response.data.data.oldNotification,
    })
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_LIST_USER_NOTIFICATION_ERROR
    })
  }
}

export const MAKE_READ_USER_NOTIFICATION = (payload) => async (dispatch) => {
  try {
    await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.NOTIFICATION_USER}/makeread`,  payload );
    
  } catch (exception) {
    
  }
}
    
export const SET_REQUEST_LIST_USER_NOTIFICATION_ERROR = (message) => (dispatch) => {
  dispatch({ type: Types.REQUEST_LIST_USER_NOTIFICATION_ERROR, payload: message })
}
